export default __webpack_public_path__ + "static/media/smileyLine.e9f95de8.svg";